
export type Industry = {
  id: string;
  name: string;
  minValue: number;
  maxValue: number;
};

export const INDUSTRIES: Industry[] = [
  { id: "fashion", name: "Fashion", minValue: 7.5, maxValue: 15 },
  { id: "technology", name: "Technology", minValue: 11.25, maxValue: 18.75 },
  { id: "health", name: "Health & Wellness", minValue: 9, maxValue: 16.5 },
  { id: "finance", name: "Finance", minValue: 13.5, maxValue: 22.5 },
  { id: "education", name: "Education", minValue: 6, maxValue: 11.25 },
  { id: "food", name: "Food & Beverage", minValue: 7.5, maxValue: 13.5 },
  { id: "travel", name: "Travel", minValue: 9, maxValue: 15 },
  { id: "media", name: "Media & Entertainment", minValue: 9, maxValue: 16.5 },
  { id: "other", name: "Other", minValue: 7.5, maxValue: 13.5 },
];

export const FREQUENCY_OPTIONS = [
  { value: 1, label: "1 day (recommended)" },
  { value: 2, label: "2 days" },
  { value: 3, label: "3 days" },
  { value: 4, label: "4 days" },
  { value: 5, label: "5 days" },
  { value: 6, label: "6 days" },
  { value: 7, label: "7 days" },
];

// Matt Media fee (can be changed in backend)
export const MATT_MEDIA_FEE_PERCENTAGE = 15; // 15%
